import React from "react";
import { Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ChakraFAIcon } from "@/components/ui/Icon";
import { FloatingToolbar, FloatingToolbarDivider, FloatingToolbarTitle, floatingToolbarGhostButtonProps } from "./FloatingToolbar";

interface UnsavedArrangementBarProps {
	onDiscard: () => void;
	onSave: () => void;
}

export function UnsavedArrangementBar(props: UnsavedArrangementBarProps): JSX.Element {
	const { t } = useTranslation();
	return (
		<FloatingToolbar zIndex={1000} data-testid="seatplan-unsaved-bar">
			<FloatingToolbarTitle>{t("seatPlan.unsavedArrangement")}</FloatingToolbarTitle>
			<FloatingToolbarDivider />
			<Button {...floatingToolbarGhostButtonProps} data-testid="seatplan-discard-button" onClick={props.onDiscard}>
				{t("seatPlan.discard")}
			</Button>
			<Button
				{...floatingToolbarGhostButtonProps}
				data-testid="seatplan-toolbar-save-button"
				leftIcon={<ChakraFAIcon icon="fa-check" variant="solid" boxSize={4} />}
				onClick={props.onSave}
			>
				{t("seatPlan.save")}
			</Button>
		</FloatingToolbar>
	);
}
